export const SLIDER_LINK = [
  {
    path: "https://wallpapers.com/images/hd/nba-youngboy-sneaker-shopping-3lvbapywkibcf0pf.webp",
  },
  {
    path: "https://i.ytimg.com/vi/ZXTqOXmDRfk/maxresdefault.jpg",
  },
  {
    path: "https://i.ytimg.com/vi/ShG9Dv_IgCY/maxresdefault.jpg",
  },
  {
    path: "https://i.ytimg.com/vi/XTC2gyVbouU/maxresdefault.jpg",
  },
  {
    path: "https://i.ytimg.com/vi/ptjcWFy8Bog/maxresdefault.jpg",
  },
  {
    path: "https://cdn.weartesters.com/wp-content/uploads/2017/03/complex-sneaker-shopping-desiigner.jpg",
  },
  {
    path: "https://wallpapers.com/images/hd/moneybagg-yo-sneaker-shopping-iobgdwwh29i8ysa8-iobgdwwh29i8ysa8.jpg",
  },
  {
    path: "https://bleedingcool.com/wp-content/uploads/2021/03/Dan-Gamache-Briskk-Sneakers-1-1200x628.jpg",
  },
  {
    path: "https://images.complex.com/complex/images/c_crop,h_759,w_1527,x_3,y_5/c_fill,dpr_auto,f_auto,q_auto,w_1400/fl_lossy,pg_1/qgmo7tc4axvoar86fmb8/undefeated?fimg-client-default",
  },
  {
    path: "https://i.pinimg.com/originals/76/4f/56/764f569e82becba955d13355531c65b0.jpg",
  },
  {
    path: "https://90snkrs.com/wp-content/uploads/2022/03/sneakers-stores-in-boston-MA-950x500.jpg",
  },
];
